import {
  getDefaultGroupFilterObjectShape,
  GROUP_FILTERS_SOURCE_KEYS
} from '@/bundles/GroupFilters/helpers/getDefaultFiltersObj';

import getters from './getters'
import mutations from './mutations'

export function groupFiltersStateBuilder () {
  const state = {};

  GROUP_FILTERS_SOURCE_KEYS.forEach(key => {
    state[key] = getDefaultGroupFilterObjectShape();
  });

  return state;
}

export default {
  namespaced: true,
  state: groupFiltersStateBuilder(),
  getters,
  actions: {},
  mutations,
}
